var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicPlanOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5007 20.865C7.78969 20.409 5.49169 18.747 4.17969 16.443",
    stroke: "#FF6D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15 6.16992C3.812 7.74092 3 9.77392 3 11.9999C3 12.5549 3.058 13.0959 3.154 13.6239",
    stroke: "#FF6D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.865C16.211 20.409 18.509 18.747 19.821 16.443",
    stroke: "#FF6D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44922 4.244C8.78522 3.458 10.3372 3 11.9992 3C13.6612 3 15.2132 3.458 16.5492 4.244",
    stroke: "#FF6D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8496 6.16992C20.1876 7.74092 20.9996 9.77392 20.9996 11.9999C20.9996 12.5549 20.9416 13.0959 20.8456 13.6239",
    stroke: "#FF6D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 9.00037L15.0004 12.0006L12.0002 15.0009L9 12.0006L12.0002 9.00037Z",
    stroke: "#FF6D34",
    strokeWidth: 1.49999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicPlanOrange);
export default __webpack_public_path__ + "static/media/basicPlanOrange.732a91b81fdd7ba8a54376b473053a9f.svg";
export { ForwardRef as ReactComponent };